module.exports = __webpack_public_path__ + "img/achievementslong.01a1d5ba.jpg";